<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component shared/cms/components/content-include/content-include.component.ts
-->
<ng-template #anchor></ng-template>
